// extracted by mini-css-extract-plugin
export default {"App":"App_App__a5kgY","navbar":"App_navbar__R0-L+","category-root":"App_category-root__guiNF","body":"App_body__N-x1t","footer":"App_footer__X5+Ib","APP":"App_APP__zJ25U"};